import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './calendar.types';
import * as constants from './calendar.constants';

export const storeCalendar = generateStoreResourceAction<types.ICalendar>(constants.STORE_CALENDAR);
export const clearCalendar = generateClearResourceAction(constants.CLEAR_CALENDAR);
